import { COMPANY } from "../data/site";
import { MessageCircle } from "lucide-react";

export const WhatsAppButton = () => (
  <a
    href={`https://wa.me/${COMPANY.whatsapp}?text=${encodeURIComponent(
      "Hi Life Line Tours! I'd like to enquire about a holiday package."
    )}`}
    target="_blank"
    rel="noreferrer"
    data-testid="whatsapp-float"
    aria-label="Chat on WhatsApp"
    className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-[#25D366] text-white pl-3.5 pr-5 py-3.5 rounded-full shadow-2xl hover:scale-105 transition-transform"
  >
    <MessageCircle size={22} className="fill-white" />
    <span className="hidden sm:inline font-semibold text-sm">Chat with us</span>
  </a>
);
